<template>
  <v-container>
    <v-data-table
      class="border-table"
      density="compact"
      :headers="headers"
      hide-no-data
      item-value="id"
      :items="shiftModels">
      <template #item="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.staff_availability_after_deductions_shiftModel }}</td>
          <td>{{ item.machine_availability_after_deductions_shiftModel }}</td>
          <td>
            <v-icon
              :data-cy="'active_shiftModel_' + item.id"
              @click="changeShiftModel(item.id)">
              {{
                1 === Number(item.active_shiftModel)
                  ? "mdi-checkbox-outline"
                  : "mdi-checkbox-blank-outline"
              }}
            </v-icon>
          </td>

          <td class="text-no-wrap">
            <EmbeddedTableActionButtons
              :data-cy="item.id"
              :clone-action="() => cloneAction(item.id)"
              :delete-action="() => deleteAction(item.id)"
              :edit-action="() => editAction(item.id)" />
          </td>
        </tr>
      </template>

      <template #[`header.actions`]>
        <div class="text-center pb-4">
          <v-btn
            class="mx-1 px-0 mt-4"
            color="#ECE6F0"
            elevated="26"
            max-width="40"
            min-width="40"
            rounded="lg"
            data-cy="add-element-shiftModel"
            @click="addAction">
            <v-icon
              color="#0F6DAC"
              size="x-large">
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
        <v-dialog
          v-model="popupForm"
          opacity="0.6"
          scrollable
          width="85%">
          <ShiftModelPopupFormView
            v-if="shiftModelId"
            :id="shiftModelId"
            :close-dialog="
              () => {
                popupForm = false;
                shiftModelId = null;
              }
            "
            :location-id="props.locationId" />
        </v-dialog>
      </template>
    </v-data-table>

    <!-- Shift Popup Form -->
  </v-container>
</template>

<script setup>
import { computed, ref } from "vue";
import { useTranslation } from "i18next-vue";

import EmbeddedTableActionButtons from "@/components/DataTable/EmbeddedTableActionButtons.vue";
import { useSpaceStore } from "@/stores/spaceStore";
import { useCalculationStore } from "@/stores/calculationStore";
import { useRouter } from "vue-router";

const { t } = useTranslation();
const spaceStore = useSpaceStore();
const calculationStore = useCalculationStore();

const popupForm = ref(false);
const shiftModelId = ref(null);

const props = defineProps({
  locationId: {
    type: String,
    required: true
  }
});

const shiftModels = computed(() => {
  return Object.entries(spaceStore.calculationElements).reduce(
    (result, [id, element]) => {
      if (
        id.endsWith("shiftModel") &&
        spaceStore.calculationElements[props.locationId].children.includes(id)
      ) {
        result.push(Object.assign({}, element, { id }));

        if (Number(element.active_shiftModel) === 1) {
          active_shiftModel.value = id;
        }
      }

      return result;
    },
    []
  );
});

const active_shiftModel = ref("");

// const active_shiftModel = computed(() => {
//   return shiftModels.value.reduce((result, shiftModel) => {
//     console.log("new active_shiftModel", shiftModel);
//     if (Number(shiftModel.active_shiftModel) === 1) {
//       return shiftModel.id;
//     }
//   }, "");
// });

const headers = computed(() => [
  {
    title: t("entities.shiftModel.fields.name"),
    align: "start",
    sortable: false,
    key: "name"
  },
  {
    title: t("entities.shiftModel.fields.description"),
    key: "description",
    sortable: false
  },
  {
    title: t("units.bracket_wrapper", {
      message: t(
        "entities.shiftModel.fields.staff_availability_after_deductions_shiftModel"
      ),
      unit: t("units.h_per_year")
    }),
    key: "staff_availability_after_deductions_shiftModel",
    sortable: false
  },
  {
    title: t("units.bracket_wrapper", {
      message: t(
        "entities.shiftModel.fields.machine_availability_after_deductions_shiftModel"
      ),
      unit: t("units.h_per_year")
    }),
    key: "machine_availability_after_deductions_shiftModel",
    sortable: false
  },
  {
    title: t("entities.shiftModel.fields.active"),
    key: "active",
    sortable: false
  },
  {
    title: "",
    key: "actions",
    sortable: false
  }
]);

function changeShiftModel(modelId) {
  if (Number(spaceStore.calculationElements[modelId].active_shiftModel) === 1) {
    // cant disable active shiftModel
  } else {
    if (active_shiftModel.value) {
      calculationStore.changeValue(
        active_shiftModel.value,
        "active_shiftModel",
        "0"
      );
    }

    calculationStore.focusElement(modelId, "active_shiftModel");
    calculationStore.changeValue(modelId, "active_shiftModel", "1");
  }
}

const router = useRouter();

const addAction = () => {
  console.warn(
    "Current active_shiftModel:",
    JSON.stringify(active_shiftModel.value)
  );
  shiftModelId.value = spaceStore.createElement("shiftModel", props.locationId);
  console.warn(
    "Current active_shiftModel:",
    JSON.stringify(active_shiftModel.value)
  );
  if (!active_shiftModel.value) {
    calculationStore.changeValue(shiftModelId.value, "active_shiftModel", "1");
  }

  router.push({
    name: "calculations-shiftModel",
    params: { nodeId: shiftModelId.value }
  });

  // popupForm.value = true;
};

const editAction = (id) => {
  shiftModelId.value = id;
  router.push({
    name: "calculations-shiftModel",
    params: { nodeId: shiftModelId.value }
  });

  // popupForm.value = true;
};

const cloneAction = (id) => {
  spaceStore.prepareClone(id);
  spaceStore.cloneOnServer(props.locationId, false);
  // router.push({
  //   name: "calculations-shiftModel",
  //   params: { nodeId: shiftModelId.value }
  // });
};

const deleteAction = (id) => {
  spaceStore.removeElement(id);
};
</script>
